const Rx = require('rx');

module.exports = function fromValuelessPromise (promise) {
  return Rx.Observable.create(observer => {
    promise
      .then(() => observer.onCompleted())
      .catch(err => observer.onError(err));
  });
};



// WEBPACK FOOTER //
// ./lib/rlink-rx/fromValuelessPromise.js